/* Core & libraries */
import React, {useCallback, useMemo} from "react";
import {useTheme} from "react-jss";
import {defineMessages, FormattedMessage, useIntl} from "react-intl";

/* Helpers, constants, custom methods, internal libraries */

/* Components */
import {ReactComponent as CloseIconCircle} from "resources/images/circled-x.svg";
import {ReactComponent as CompleteIconCircle} from "resources/images/complete-icon-circle.svg";
import { ReactComponent as ClockIcon } from "../../../../resources/images/clock.svg";
import { ReactComponent as AlertIcon} from "../../../../resources/images/alert-circle-default.svg";

import UCButton from "components/buttons";
import UCAutocomplete from "components/ucautocomplete";

/* Styles */
import styles from "./styles.js"

const messages = defineMessages({
  searchPlaceholder: {
    id: "retro.grid.header.search",
  },
});

export const CREDIT_REQUEST_HISTORY_GRID_TYPE = {
  APPROVED: 'APPROVED',
  PENDING: 'PENDING',
  INELIGIBLE: 'INELIGIBLE',
  FAILED: 'FAILED',
}
const CreditRequestHistoryFilters = (props) => {
  const {gridOptions, setGridOptions} = props;
  const theme = useTheme();
  const classes = styles({theme});

  const applyFilters = useCallback((filters) => {
    setGridOptions(gridOptions => ({
      ...gridOptions,
      ...filters,
      filters: {
        ...gridOptions.filters,
        ...filters?.filters,
      }
    }));
  }, []);

  const setGridStatus = useCallback((status) => () => {
    applyFilters({page: 1, status})
  }, []);

  const setGridSearchTerm = useCallback((searchterm = undefined) => {
    applyFilters({page: 1, searchterm})
  }, []);

  const intl = useIntl();

  return (
    <>
      <div className={classes.filters}>
        <div className={classes.filterContainer}>
          <div className={classes.filterButtons}>
            <div className={classes.filterGroups}>
              <UCButton
                onClick={setGridStatus(CREDIT_REQUEST_HISTORY_GRID_TYPE.APPROVED)}
                type="default"
                className={`${classes.filter} ${gridOptions?.status === CREDIT_REQUEST_HISTORY_GRID_TYPE.APPROVED ? classes.active : ''}`}
                text={<FormattedMessage id="retro.grid.header.filters.approved" />}
                icon={<CompleteIconCircle />}
              />
              <UCButton
                onClick={setGridStatus(CREDIT_REQUEST_HISTORY_GRID_TYPE.PENDING)}
                type="default"
                className={`${classes.filter} ${gridOptions?.status === CREDIT_REQUEST_HISTORY_GRID_TYPE.PENDING ? classes.active : ''}`}
                text={<FormattedMessage id="retro.grid.header.filters.pending" />}
                icon={<ClockIcon />}
              />
              <UCButton
                onClick={setGridStatus(CREDIT_REQUEST_HISTORY_GRID_TYPE.INELIGIBLE)}
                type="default"
                className={`${classes.filter} ${gridOptions?.status === CREDIT_REQUEST_HISTORY_GRID_TYPE.INELIGIBLE ? classes.active : ''}`}
                text={<FormattedMessage id="retro.grid.header.filters.ineligible" />}
                icon={<CloseIconCircle />}
              />
              {/*<UCButton*/}
              {/*  onClick={setGridStatus(CREDIT_REQUEST_HISTORY_GRID_TYPE.FAILED)}*/}
              {/*  type="default"*/}
              {/*  className={`${classes.filter} ${gridOptions?.status === CREDIT_REQUEST_HISTORY_GRID_TYPE.FAILED ? classes.active : ''}`}*/}
              {/*  text={<FormattedMessage id="retro.grid.header.filters.failed" />}*/}
              {/*  icon={<AlertIcon />}*/}
              {/*/>*/}
            </div>
          </div>
        </div>

        <div className={classes.filterMenuContainer}>
          <UCAutocomplete
            value={gridOptions?.searchterm}
            showMinError={false}
            type="CREDIT_REQUEST_HISTORY"
            className={classes.autocomplete}
            getOptions={setGridSearchTerm}
            placeholder={intl.formatMessage(messages.searchPlaceholder)}
            onClear={setGridSearchTerm}
          />
        </div>
      </div>
    </>
  );
}

export default CreditRequestHistoryFilters;
